import axios from 'axios';

export async function sendPaypalPayment({ servicePlanId, amount, currency, description, userType, userId }) {
    try {
        const { data } = await axios.post(
            '/plan-payNow',
            { servicePlanId, amount, currency, description, userType, userId },
            { withCredentials: true }
        );

        const { status, errorMessage, redirect } = data;

        if (status === 200 && redirect) {
            window.location = redirect;
        }

        return { status, errorMessage };

    } catch (error) {
        return {
            status: error.response?.status || 500,
            errorMessage: error.response?.data?.errorMessage || 'Something went wrong'
        };
    }
}
